module.exports = __webpack_public_path__ + "img/shebei.e32902c1.png";